import React from 'react';
import Simulator from './components/Simulator';
import './css/Control.css'

class Control extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            totalpotency: 0,
            potencypersecond: 0,
            dotpotency: 0,
            gcdtime: 2.50,
            ogcdtime: 0.6,
            totaltime: 0,
            tabledata: [],
        };
        this.handleGCDChange = this.handleGCDChange.bind(this);
        this.handleOGCDChange = this.handleOGCDChange.bind(this);
    }

    updateParentData = (array) => {
        if (array.length > 0) {
            this.setState({
                totalpotency: array[array.length - 1].tpotency.toFixed(2),
                potencypersecond: ((array[array.length - 1].tpotency + array[array.length - 1].dotpotency) / array[array.length - 1].time).toFixed(3),
                totaltime: array[array.length - 1].time,
                dotpotency: array[array.length - 1].dotpotency.toFixed(2),
                tabledata: array
            });
        }
        else {
            this.setState({
                totalpotency: 0,
                potencypersecond: 0,
                totaltime: 0,
                dotpotency: 0,
                tabledata: [],
            });
        }
    }

    handleGCDChange(event) {
        this.setState({
            gcdtime: parseFloat(event.target.value)
        });
    }
    handleOGCDChange(event) {
        this.setState({
            ogcdtime: parseFloat(event.target.value)
        });
    }

    render() {
        return (
            <div id="ControlPanel" class="panel-group">
                <div class="panel-body col-sm-12" id="controlpanel">
                    <div class="panel-heading">
                        <span class="subheader">Statistics</span>
                    </div>
                    <div class="col-sm-4">
                        <div id="controlitem">Total Time: {this.state.totaltime.toFixed(2)}</div>
                        <div id="controlitem">Total Potency: {this.state.totalpotency}</div>
                        <div id="controlitem">Total Dot Potency: {this.state.dotpotency}</div>
                    </div>
                    <div class="col-sm-4">
                        <div id="controlitem">Potency Per Second: <b>{this.state.potencypersecond}</b></div>
                    </div>
                    <div class="col-sm-4">
                        <div id="controlitem">GCD: <input type="number" step="0.01" value={this.state.gcdtime} onChange={this.handleGCDChange} />  seconds</div>
                        <div id="controlitem">oGCD: <input type="number" step="0.01" value={this.state.ogcdtime} onChange={this.handleOGCDChange} /> seconds</div>
                    </div>
                </div>
                <Simulator updateparent={this.updateParentData} data={this.state.tabledata} gcdtime={this.state.gcdtime} ogcdtime={this.state.ogcdtime} />
            </div >
        )
    }
}

export default Control;


// WEBPACK FOOTER //
// ./src/Control.js